<template>

    <div class="r-column fr bgw mht-400">
        <Crumb v-if="typeId" :typeId="typeId"></Crumb>
        <div class="pnews enroll-news news-ct news-cur pl30 pr20">
            <div v-if="children" class="enroll-types fs16 mb40">
                <div :class="!sid ? 'active' : ''" 
                    class="dinline-block tcenter mr10 mb10 cpointer"
                    @click="changeLink('')">
                    全部 <span class="iconfont icon-youjiantou ml5"></span>
                </div>
                <!-- <router-link 
                    v-for="item in children" 
                    :key="item" 
                    :to="`${$params.baseDir}edu/enroll/${typeId}?sid=${item}`"
                    :class="sid == item ? 'active' : ''"
                    class="dinline-block tcenter mr10 mb10 cpointer">{{$params.newsType[item]['stitle']}}
                </router-link > -->

                <span v-for="item in children" 
                    :key="item" 
                    :to="`${$params.baseDir}edu/enroll/${typeId}?sid=${item}`"
                    :class="sid == item ? 'active' : ''"
                    class="dinline-block tcenter mr10 mb10 cpointer"
                    @click="changeLink(item)">
                    {{$params.newsType[item]['stitle']}}
                </span>
            </div>
            <div v-if="!count" class="tcenter tc9 fs18 no-cont">
                <div class="iconfont icon-kongneirong"></div>
                抱歉，没有相关内容
            </div>
            <template v-else>
                <router-link v-for="item in newsList" :key="item.id" 
                    :to="`${$params.baseDir}edu/detail/${item.id}?typeId=${typeId}`" 
                    class="news-s dblock lh20 t-hidden mb20 prelative before pl15 pr10 fs0" :title="item.title">
                    <span class="title dinline-block fs16 t-hidden">{{item.title}}</span>
                    <span class="date tc9 fr fs16 tright">{{item.open_time}}</span>
                </router-link>
            </template>
      
          
        </div>
        <Page v-if="count" :pageNum="page + 1" :pageSize="pageSize" :count="count" @chagePage="chagePage" />

    </div>

</template>
<script>
import Crumb from '@/components/common/Crumb'
import Page from '@/components/common/MyPagination'
import { throws } from 'assert'
export default {
    data() {
        return {
            children: [],
            newsList: [],
            typeId: 0,
            sid: 0,
            page: 0,
            pageSize: 15,
            count: 0,
            isFirst: true
        }
    },
    components: {
        Crumb,
        Page
    },
    created() {
        this.initData()
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function (nV, oV) {
                //if (nV.params.id != oV.params.id) {
                    this.isLoad = false
                    this.count = 0
                    this.page = 0
                    this.initData()
                //}
            }
        }
    },
    methods: {
        initData() {
            this.typeId = this.$route.params.id
            this.sid = this.$route.query.sid  ? this.$route.query.sid : 0
            this.children = this.$params.newsType[this.typeId]['children']
            this.getNewsList()

        },
        getNewsList() {
            let query = {
                category_id: this.typeId,
                page: this.page + 1,
                perPage: this.pageSize
            }
            let url = 'article/list-second-category'
            if(this.sid){
                url = 'article/list'
                query.category_id = this.sid
            }
            this.$request.get(url , query, res => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    this.newsList = data.data
                    this.count = parseInt(data.total)
                    this.isLoad = false
                    console.log('------------')
            console.log(this.children)
                }
            }, err => {
                console.log(err)
                this.isLoad = false
            })
        },
        chagePage(page) {
            this.page = page - 1
            this.getNewsList()
        },
        changeLink(item){
            if(item)
                this.sid = item
            else
                this.sid = 0
            this.page = 0
            this.getNewsList()

        }

    }
}
</script>
<style scope>
.no-cont {
    margin-top: 80px;
}
</style>
